
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baza-wiedzy",
      function () {
        return require("private-next-pages/baza-wiedzy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baza-wiedzy"])
      });
    }
  